export default __webpack_public_path__ + "70035dafad19b29e19789ca5bfb4184e.svg";